import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import PrologueImage from "../components/PrologueImage";
import BodyCard from "../components/BodyCard";
import Section from "../components/Section";
import SimpleTextPage from "../components/SimpleTextPage";

const mapSrc =
  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d786.2675918883385!2d23.7855767!3d37.9754871!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a197f3424f2aa5%3A0x7f9f857e88997997!2zzpXPgc6zzrHPg8-Ezq7Pgc65zr8gzpfOu861zrrPhM-BzrnOus-Ozr0gzpzOt8-HzrHOvc-Ozr0gJiDOl867zrXOus-Ez4HOv869zrnOus-Ozr0gzpnPg8-Hz43Ov8-CIM6VzpzOoA!5e0!3m2!1sel!2sgr!4v1783867507209!5m2!1sel!2sgr";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{`${t("contact")} | PEL Group`}</title>
        <meta name="description" content={t("contactIntro")} />
      </Helmet>
      <PrologueImage
        title={t("contact")}
        subtitle={t("contactIntro")}
        image="/contact.png"
      />
      <BodyCard>
        <SimpleTextPage
          noCard={true}
          pageId="003179dc-8df4-4364-abd5-b4dd99c39efa"
        />
        <Section
          title={t("map")}
          content={
            <div className="leaflet-container">
              <iframe
                src={mapSrc}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="PEL Group location map"
              />
            </div>
          }
        />
      </BodyCard>
    </>
  );
}
